import clsx from 'clsx';
import React, { ReactNode, useState } from 'react';
import SearchIcon from '../../assets/icons/search-icon.svg?react';

interface SearchInputProps {
  otherClasses?: {
    input?: string;
    container?: string;
    label?: string;
  };
  value: string | number;
  errorMessage?: string;
  label?: string | ReactNode;
  disabled?: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: any) => void;
  placeholder: string;
  name: string;
}

const SearchInput: React.FC<SearchInputProps> = ({
  otherClasses,
  value,
  disabled,
  errorMessage,
  label,
  name,
  onChange,
  placeholder,
  onBlur,
}) => {
  const searchInputClasses = clsx(
    otherClasses?.container,
    'flex flex-col gap-2.5 items-start relative w-fit',
  );

  const inputClasses = clsx(
    otherClasses?.input,
    'w-full h-12 lg:h-60 global-transition rounded-10 placeholder:text-neutral-tones-text/50 text-neutral-tones-text ring -tracking-form-input py-4 lg:py-5 pl-12 lg:pl-14 pr-5 text-base font-normal font-inter-variable outline-none disabled:ring-neutral-tones-text/35 disabled:placeholder:text-neutral-tones-text/35 disabled:text-neutral-tones-text/35 disabled:cursor-not-allowed [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none',
    errorMessage !== ''
      ? 'ring-brand-posh-pink ring-2'
      : 'ring-neutral-tones-text/50 focus:ring-2 focus:ring-brand-byzantine',
  );
  const labelClasses = clsx(
    otherClasses?.label,
    'text-form-label  font-bold -tracking-form-label font-inter-variable',
    disabled
      ? 'text-neutral-tones-text/35 cursor-not-allowed'
      : 'text-neutral-tones-text',
  );
  const [isFocused, setIsFocused] = useState(false);
  const handleFocus = () => setIsFocused(true);
  const handleBlur = (e: any) => {
    setIsFocused(false);
    if (onBlur) onBlur(e);
  };

  return (
    <div className={searchInputClasses} data-testid="search-input">
      {label && (
        <label htmlFor={name} className={labelClasses}>
          {label}
        </label>
      )}
      <div className="relative w-full">
        <SearchIcon
          className={clsx(
            'absolute top-2/4 left-5 h-6 w-6 -translate-y-2/4 lg:h-8 lg:w-8',
            isFocused
              ? '[&>g>path]:fill-brand-byzantine'
              : '[&>g>path]:fill-neutral-tones-text',
          )}
        />
        <input
          disabled={disabled}
          type="search"
          onBlur={handleBlur}
          name={name}
          id={name}
          value={value}
          autoComplete="new-password"
          onChange={(e) => onChange(e)}
          className={inputClasses}
          placeholder={placeholder}
          onFocus={handleFocus}
        />
      </div>
      {errorMessage !== '' && (
        <span className="font-inter-variable text-brand-posh-pink absolute -bottom-6 left-0 text-xs font-normal">
          {errorMessage}
        </span>
      )}
    </div>
  );
};

export default SearchInput;
